import BaseModel from '../core/BaseModel'

export default class DistrictModel extends BaseModel {

    constructor() {
        super({
                name: "district",
                tableName: 'district',
                label: "Danh Sách Quận/Huyện",
                display_key: 'name',
                default_order: {key: 'id', direction: 'asc'}
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    width: 4,
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: 'id',
                    type: "Int",
                    label: 'ID',
                    primaryKey: true,
                    // edit: {
                    //     add: false,
                    //     edit: false
                    // },
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Tên quận/huyện',
                    width: 15,
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                    // display: false
                },
                plain_name: {
                    name: 'plain_name',
                    type: "Int",
                    label: 'plain_name',
                    display: false
                },
            },)
    }

}